<template>
  <footer class="footer">
    <FooterCTAs />
    <section class="footer-main">
      <div class="max-w-4xl mx-auto px-4 py-12">
        <FooterLogo />
        <div class="footer-info flex flex-col md:flex-row justify-between mt-8">
          <div class="text-center md:text-left mb-8 md:mb-0">
            <FooterContacts />
          </div>
          <div class="text-center md:text-left">
            <FooterLocations />
          </div>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
  import FooterCTAs from './FooterCTAs.vue';
  import FooterContacts from './FooterContacts.vue';
  import FooterLocations from './FooterLocations.vue';
  import FooterLogo from './FooterLogo.vue';

  export default {
    name: 'SiteFooter',
    components: {
      FooterCTAs,
      FooterContacts,
      FooterLocations,
      FooterLogo
    }
  };
</script>

<style scoped>
  .footer {
    text-transform: uppercase;
  }

  .footer-main {
    color: var(--empire-white-text);
    background: var(--empire-black-bg);
  }
</style>
